import Navbar from '../home/components/Navbar';
import Footer from '../home/components/Footer';
import SEOHead from '../../components/SEOHead';
import { useState } from 'react';

const SITE_URL = import.meta.env.VITE_SITE_URL || 'https://example.com';

const testimonialsSchema = {
  '@context': 'https://schema.org',
  '@type': 'WebPage',
  name: 'Client Reviews & Testimonials - Fluffy Pets',
  url: `${SITE_URL}/testimonials`,
  description:
    'Read 2,500+ verified reviews from happy pet owners. Fluffy Pets holds a 4.9/5 rating for grooming, boarding, veterinary care and training services.',
  isPartOf: { '@type': 'WebSite', name: 'Fluffy Pets', url: SITE_URL },
  aggregateRating: {
    '@type': 'AggregateRating',
    ratingValue: '4.9',
    reviewCount: '2500',
    bestRating: '5',
    worstRating: '1',
  },
  review: [
    {
      '@type': 'Review',
      author: { '@type': 'Person', name: 'Jennifer Martinez' },
      reviewRating: { '@type': 'Rating', ratingValue: '5', bestRating: '5' },
      reviewBody: 'Absolutely amazing! My golden retriever Max looks like a show dog after every grooming session.',
      datePublished: '2026-03-10',
    },
    {
      '@type': 'Review',
      author: { '@type': 'Person', name: 'Robert Anderson' },
      reviewRating: { '@type': 'Rating', ratingValue: '5', bestRating: '5' },
      reviewBody: 'We boarded our beagle Luna here for two weeks. The daily photo updates gave us so much peace of mind!',
      datePublished: '2026-02-24',
    },
    {
      '@type': 'Review',
      author: { '@type': 'Person', name: 'Sarah Kim' },
      reviewRating: { '@type': 'Rating', ratingValue: '5', bestRating: '5' },
      reviewBody: "Dr. Johnson saved my cat Whiskers' life! Thorough examination and exceptional emergency care.",
      datePublished: '2026-03-03',
    },
  ],
};

// ... existing code ...

export default function TestimonialsPage() {
  const [selectedCategory, setSelectedCategory] = useState('all');

  const categories = [
    { id: 'all', label: 'All Reviews' },
    { id: 'grooming', label: 'Grooming' },
    { id: 'boarding', label: 'Boarding' },
    { id: 'veterinary', label: 'Veterinary' },
    { id: 'training', label: 'Training' }
  ];

  const testimonials = [
    {
      name: 'Jennifer Martinez',
      service: 'grooming',
      rating: 5,
      image: 'https://public.readdy.ai/ai/img_res/7e4e96d7757148bf7bcbc8e57cce80c3.jpg',
      text: 'Absolutely amazing! My golden retriever Max looks like a show dog after every grooming session. The staff is so gentle and patient with him. I would not trust anyone else with my furry baby. The attention to detail is incredible!',
      pet: 'Max (Golden Retriever)',
      date: '2 weeks ago'
    },
    {
      name: 'Robert Anderson',
      service: 'boarding',
      rating: 5,
      image: 'https://readdy.ai/api/search-image?query=satisfied%20businessman%20with%20his%20happy%20beagle%20dog%20in%20comfortable%20boarding%20facility%20smiling%20confidently%20at%20camera%20with%20purple%20and%20pink%20gradient%20lighting%20high%20quality%20portrait%20photography&width=400&height=400&seq=testimonial-2&orientation=squarish',
      text: 'We boarded our beagle Luna here for two weeks while on vacation. The daily photo updates gave us so much peace of mind! Luna came home happy and well-cared for. The facility is spotless and the staff truly loves what they do.',
      pet: 'Luna (Beagle)',
      date: '1 month ago'
    },
    {
      name: 'Sarah Kim',
      service: 'veterinary',
      rating: 5,
      image: 'https://readdy.ai/api/search-image?query=caring%20young%20woman%20holding%20her%20healthy%20persian%20cat%20in%20modern%20veterinary%20clinic%20smiling%20warmly%20at%20camera%20with%20purple%20and%20pink%20gradient%20lighting%20high%20quality%20portrait%20photography&width=400&height=400&seq=testimonial-3&orientation=squarish',
      text: 'Dr. Johnson saved my cat Whiskers life! She was so thorough in her examination and explained everything clearly. The emergency care was exceptional. I am forever grateful for the compassionate and professional service we received.',
      pet: 'Whiskers (Persian Cat)',
      date: '3 weeks ago'
    },
    {
      name: 'Michael Brown',
      service: 'training',
      rating: 5,
      image: 'https://readdy.ai/api/search-image?query=proud%20man%20with%20his%20well-trained%20german%20shepherd%20dog%20in%20outdoor%20training%20area%20smiling%20confidently%20at%20camera%20with%20purple%20and%20pink%20gradient%20lighting%20high%20quality%20portrait%20photography&width=400&height=400&seq=testimonial-4&orientation=squarish',
      text: 'Emily transformed our German Shepherd Rocky from an unruly puppy into a well-behaved companion. Her positive reinforcement methods work wonders! We learned so much in the training classes. Highly recommend to all dog owners!',
      pet: 'Rocky (German Shepherd)',
      date: '1 week ago'
    },
    {
      name: 'Lisa Thompson',
      service: 'grooming',
      rating: 5,
      image: 'https://readdy.ai/api/search-image?query=delighted%20woman%20with%20her%20beautifully%20groomed%20poodle%20in%20elegant%20pet%20salon%20smiling%20warmly%20at%20camera%20with%20purple%20and%20pink%20gradient%20lighting%20high%20quality%20portrait%20photography&width=400&height=400&seq=testimonial-5&orientation=squarish',
      text: 'My poodle Bella always gets compliments after her grooming appointments here! Michael is an artist with scissors. The spa treatments are luxurious and Bella actually enjoys going. Worth every penny for the quality service!',
      pet: 'Bella (Poodle)',
      date: '4 days ago'
    },
    {
      name: 'David Wilson',
      service: 'boarding',
      rating: 5,
      image: 'https://readdy.ai/api/search-image?query=happy%20senior%20man%20with%20his%20energetic%20labrador%20dog%20in%20spacious%20boarding%20facility%20smiling%20warmly%20at%20camera%20with%20purple%20and%20pink%20gradient%20lighting%20high%20quality%20portrait%20photography&width=400&height=400&seq=testimonial-6&orientation=squarish',
      text: 'Charlie stayed here for a week and had the time of his life! The play areas are fantastic and the staff sent us videos of him having fun. He was so tired and happy when we picked him up. Best boarding facility in town!',
      pet: 'Charlie (Labrador)',
      date: '2 months ago'
    },
    {
      name: 'Amanda Garcia',
      service: 'veterinary',
      rating: 5,
      image: 'https://readdy.ai/api/search-image?query=relieved%20young%20woman%20with%20her%20healthy%20small%20dog%20in%20bright%20veterinary%20clinic%20smiling%20warmly%20at%20camera%20with%20purple%20and%20pink%20gradient%20lighting%20high%20quality%20portrait%20photography&width=400&height=400&seq=testimonial-7&orientation=squarish',
      text: 'The veterinary team here is outstanding! They diagnosed my dog Milo condition quickly and the treatment plan was perfect. The follow-up care and communication were excellent. I feel so lucky to have found such caring professionals.',
      pet: 'Milo (Corgi)',
      date: '3 weeks ago'
    },
    {
      name: 'James Lee',
      service: 'training',
      rating: 5,
      image: 'https://readdy.ai/api/search-image?query=satisfied%20man%20with%20his%20obedient%20husky%20dog%20in%20professional%20training%20facility%20smiling%20confidently%20at%20camera%20with%20purple%20and%20pink%20gradient%20lighting%20high%20quality%20portrait%20photography&width=400&height=400&seq=testimonial-8&orientation=squarish',
      text: 'Our husky Zeus was a handful before training classes. Now he walks perfectly on leash and follows commands reliably. The trainers are knowledgeable and patient. The group classes were fun and effective. Highly recommended!',
      pet: 'Zeus (Husky)',
      date: '1 month ago'
    },
    {
      name: 'Emily Davis',
      service: 'grooming',
      rating: 5,
      image: 'https://readdy.ai/api/search-image?query=cheerful%20woman%20with%20her%20freshly%20groomed%20yorkshire%20terrier%20in%20modern%20pet%20salon%20smiling%20warmly%20at%20camera%20with%20purple%20and%20pink%20gradient%20lighting%20high%20quality%20portrait%20photography&width=400&height=400&seq=testimonial-9&orientation=squarish',
      text: 'Daisy looks adorable after every grooming session! The staff is so sweet and accommodating. They always fit us in even with short notice. The quality of work is consistently excellent. We have been loyal customers for years!',
      pet: 'Daisy (Yorkshire Terrier)',
      date: '1 week ago'
    }
  ];

  const filteredTestimonials = selectedCategory === 'all'
    ? testimonials
    : testimonials.filter(t => t.service === selectedCategory);

  return (
    <div className="min-h-screen bg-white">
      <SEOHead
        title="Client Reviews &amp; Testimonials | 4.9 Stars - Fluffy Pets San Francisco"
        description="Read 2,500+ verified reviews from happy pet owners. Fluffy Pets earns a 4.9/5 rating for professional pet grooming, boarding, veterinary care, and training in San Francisco."
        keywords="fluffy pets reviews, pet care testimonials, pet grooming reviews San Francisco, boarding reviews, veterinary reviews"
        canonical={`${SITE_URL}/testimonials`}
        schema={testimonialsSchema}
      />
      <Navbar />
      
      {/* Hero Section */}
      <section className="relative pt-32 pb-20 px-6 overflow-hidden">
        <div className="absolute inset-0 bg-gradient-to-br from-purple-50 via-pink-50 to-purple-50"></div>
        <div className="absolute top-20 right-10 w-72 h-72 bg-gradient-to-br from-purple-300/30 to-pink-300/30 rounded-full blur-3xl"></div>
        <div className="absolute bottom-10 left-10 w-96 h-96 bg-gradient-to-tr from-pink-300/30 to-purple-300/30 rounded-full blur-3xl"></div>
        <div className="relative max-w-7xl mx-auto text-center">
          <h1 className="text-5xl md:text-6xl font-black mb-6 bg-gradient-to-r from-purple-600 to-pink-600 bg-clip-text text-transparent">
            What Our Clients Say
          </h1>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto leading-relaxed">
            Don&apos;t just take our word for it. Hear from the pet parents who trust us with their beloved companions every day.
          </p>
        </div>
      </section>

      {/* Stats Section */}
      <section className="py-16 px-6">
        <div className="max-w-7xl mx-auto">
          <div className="grid md:grid-cols-4 gap-8 text-center">
            {[
              { icon: 'ri-star-fill', number: '4.9/5', label: 'Average Rating' },
              { icon: 'ri-chat-smile-3-line', number: '2,500+', label: 'Happy Reviews' },
              { icon: 'ri-user-heart-line', number: '98%', label: 'Satisfaction Rate' },
              { icon: 'ri-trophy-line', number: '15+', label: 'Awards Won' }
            ].map((stat, index) => (
              <div key={index} className="bg-gradient-to-br from-purple-50 to-pink-50 rounded-2xl p-8">
                <div className="w-16 h-16 flex items-center justify-center bg-gradient-to-br from-purple-500 to-pink-500 rounded-full mx-auto mb-4">
                  <i className={`${stat.icon} text-3xl text-white`}></i>
                </div>
                <div className="text-4xl font-black mb-2 bg-gradient-to-r from-purple-600 to-pink-600 bg-clip-text text-transparent">{stat.number}</div>
                <div className="text-gray-600 font-semibold">{stat.label}</div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Filter Section */}
      <section className="py-8 px-6">
        <div className="max-w-7xl mx-auto">
          <div className="flex flex-wrap justify-center gap-4">
            {categories.map((category) => (
              <button key={category.id} onClick={() => setSelectedCategory(category.id)}
                className={`px-6 py-3 rounded-full font-semibold transition-all duration-300 whitespace-nowrap cursor-pointer ${
                  selectedCategory === category.id
                    ? 'bg-gradient-to-r from-purple-500 to-pink-500 text-white shadow-lg'
                    : 'bg-gray-100 text-gray-600 hover:bg-gray-200'
                }`}>
                {category.label}
              </button>
            ))}
          </div>
        </div>
      </section>

      {/* Testimonials Grid */}
      <section className="py-16 px-6">
        <div className="max-w-7xl mx-auto">
          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
            {filteredTestimonials.map((testimonial, index) => (
              <div key={index} className="bg-white rounded-2xl p-8 shadow-lg hover:shadow-2xl transition-all duration-300 border border-gray-100">
                <div className="flex items-center mb-6">
                  <div className="w-16 h-16 rounded-full overflow-hidden mr-4 flex-shrink-0">
                    <img src={testimonial.image} alt={testimonial.name} className="w-full h-full object-cover object-top" />
                  </div>
                  <div className="flex-1 min-w-0">
                    <h3 className="font-bold text-gray-800 truncate">{testimonial.name}</h3>
                    <p className="text-sm text-gray-500 truncate">{testimonial.pet}</p>
                  </div>
                </div>
                <div className="flex items-center mb-4">
                  {[...Array(testimonial.rating)].map((_, i) => (
                    <i key={i} className="ri-star-fill text-yellow-400 text-lg"></i>
                  ))}
                  <span className="ml-2 text-sm text-gray-500">{testimonial.date}</span>
                </div>
                <p className="text-gray-600 leading-relaxed mb-4">{testimonial.text}</p>
                <div className="pt-4 border-t border-gray-100">
                  <span className="inline-block px-4 py-2 bg-gradient-to-r from-purple-100 to-pink-100 text-purple-700 rounded-full text-sm font-semibold capitalize">
                    {testimonial.service}
                  </span>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-20 px-6 bg-gradient-to-br from-purple-50 via-pink-50 to-purple-50">
        <div className="max-w-4xl mx-auto text-center">
          <h2 className="text-4xl md:text-5xl font-black mb-6 bg-gradient-to-r from-purple-600 to-pink-600 bg-clip-text text-transparent">
            Ready to Experience the Difference?
          </h2>
          <p className="text-xl text-gray-600 mb-10 leading-relaxed">
            Join thousands of satisfied pet parents who trust Fluffy Pets with their furry family members. Book your appointment today!
          </p>
          <a href="/booking" className="inline-block px-10 py-5 bg-gradient-to-r from-purple-500 to-pink-500 text-white text-lg font-bold rounded-full hover:shadow-2xl transition-all duration-300 whitespace-nowrap cursor-pointer">
            Book an Appointment
          </a>
        </div>
      </section>

      <Footer />
    </div>
  );
}
